import { List, ListItem, ListItemButton, ListItemText, Typography, Divider } from '@mui/material';
import type { JournalEntryListItem } from '../../types/api.types';

interface Props {
  entries: JournalEntryListItem[];
  onSelect: (id: string) => void;
}

export const EntryList = ({ entries, onSelect }: Props) => {
  if (entries.length === 0) {
    return (
      <Typography color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
        No entries yet. Write your first entry!
      </Typography>
    );
  }

  return (
    <List disablePadding>
      {entries.map((entry, i) => (
        <div key={entry.id}>
          <ListItem disablePadding>
            <ListItemButton onClick={() => onSelect(entry.id)}>
              <ListItemText
                primary={entry.title || new Date(entry.createdAt).toLocaleDateString()}
                secondary={entry.snippet}
                secondaryTypographyProps={{ noWrap: true }}
              />
            </ListItemButton>
          </ListItem>
          {i < entries.length - 1 && <Divider />}
        </div>
      ))}
    </List>
  );
};
